<section>
  <h2>
    <nb-icon icon="briefcase-outline"></nb-icon><span>{{ 'userprojects' | translate}}</span>
  </h2>
  @if (!readonly) {
    <div class="buttons">
      <button nbButton type="button" shape="rectangle" size="small" status="primary" (click)="this.openExperience()">
        <nb-icon [icon]="'plus-outline'"></nb-icon><span>{{ 'addexperience' | translate }}</span>
      </button>
    </div>
  }
  @if ((experiences | filter:{type: [ExperienceType.School]}:true); as comps) {
    @if (comps.length) {
      @for (company of comps; track company) {
        <article>
          <div class="panel">
            <div class="company">
              @if (company.logo) {
                <bst-photo-well [file]="company.logo" [color]="company.is_tenant_root ? 'var(--teamer-accent)' : '#f7f9fc'" shape="rectangle"></bst-photo-well>
              }
              <div class="head">
                <div>
                  <label>
                    <span><b>{{ company.name }}</b></span>
                    @if (company.start) {
                      <span class="duration-pill">{{ company | span }}</span>
                    }
                  </label>
                  <label>
                    <span><b>{{ company.position }}</b></span>
                    @if (company.location) {
                      <span>{{ (company.position ? ', ' : '') + company.location }}</span>
                    }
                    @if (company.start) {
                      <span>,&nbsp;&nbsp;<i>{{ company | frame }}</i></span>
                    }
                  </label>
                </div>
                @if (!readonly) {
                  <div class="edit-button">
                    <button nbButton size="tiny" type="button" (click)="openExperience(company)">
                      <nb-icon [icon]="'edit-2-outline'"></nb-icon><span>{{ 'edit...' | translate }}</span>
                    </button>
                  </div>
                }
              </div>
              @if (company.description) {
                <div class="body">
                  {{ company.description }}
                </div>
              }
              @if ((company.items | filter:{type: ExperienceType.CustomResponsibility}); as cres) {
                <div class="foot">
                  <ul>
                    @for (res of cres; track res) {
                      <li>
                        {{ res.name }}
                      </li>
                    }
                  </ul>
                </div>
              }
            </div>
            @for (item of company.items | filter:{type: [ExperienceType.Project, ExperienceType.CustomProject]}; track item) {
              <div class="project">
                <div class="head">
                  <div>
                    @if (item.name) {
                      <label>
                        <span><b>{{ item.name }}</b></span>
                        @if (item.company) {
                          <span>&nbsp;{{ ('at' | translate) }}&nbsp;<b>{{ item.company }}</b></span>
                        }
                        @if (item.start) {
                          <span class="duration-pill">{{ item | span }}</span>
                        }
                      </label>
                    }
                    <label>
                      <span><b>{{ item.position }}</b></span>
                      @if (item.location) {
                        <span>,&nbsp;{{ item.location }}</span>
                      }
                      @if (item.start) {
                        <span>,&nbsp;&nbsp;<i>{{ item | frame }}</i></span>
                      }
                    </label>
                  </div>
                  @if (!readonly) {
                    <div class="edit-button">
                      <button nbButton size="tiny" type="button" (click)="openExperience(company, item)">
                        <nb-icon [icon]="'edit-2-outline'"></nb-icon>
                      </button>
                    </div>
                  }
                </div>
                @if (item.description) {
                  <div class="body">
                    {{ item.description }}
                  </div>
                }
                @if (item.items && item.items.length) {
                  <div class="foot">
                    <ul>
                      @for (res of item.items; track res) {
                        <li>
                          {{ res.name }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
            @for (item of company.items | filter:{type: ExperienceType.CustomPosition}; track item) {
              <div class="position">
                <div class="head">
                  <div>
                    @if (item.name) {
                      <label>
                        <span><b>{{ item.name }}</b></span>
                        @if (item.location) {
                          <span>,&nbsp;{{ item.location }}</span>
                        }
                        @if (item.start) {
                          <span>,&nbsp;&nbsp;<i>{{ item | frame }}</i></span>
                        }
                      </label>
                    }
                  </div>
                  @if (!readonly) {
                    <div class="edit-button">
                      <button nbButton size="tiny" type="button" (click)="openExperience(company, item)">
                        <nb-icon [icon]="'edit-2-outline'"></nb-icon>
                      </button>
                    </div>
                  }
                </div>
                @if (item.description) {
                  <div class="body">
                    {{ item.description }}
                  </div>
                }
                @if (item.items && item.items.length) {
                  <div class="foot">
                    <ul>
                      @for (res of item.items; track res) {
                        <li>
                          {{ res.name }}
                        </li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
          </div>
          <div class="panel-footer"></div>
        </article>
      }
    } @else {
      @if (readonly) {
        <label class="none">{{ 'nonelisted' | translate }}</label>
      }
    }
  } @else {
    @if (readonly) {
      <label class="none">{{ 'nonelisted' | translate }}</label>
    }
  }

  <h2>
    <nb-icon icon="book-open-outline"></nb-icon><span>{{ 'usereducation' | translate}}</span>
  </h2>
  @if (!readonly) {
    <div class="buttons">
      <button nbButton type="button" shape="rectangle" size="small" status="primary" (click)="this.openExperience(null, null, ExperienceType.School)">
        <nb-icon [icon]="'plus-outline'"></nb-icon><span>{{ 'addeducation' | translate }}</span>
      </button>
    </div>
  }
  @if ((experiences | filter:{type: ExperienceType.School}:false); as schools) {
    @if (schools.length) {
      @for (school of schools; track school) {
        <article class="school">
          <div class="panel">
            <div class="company">
              @if (school.logo) {
                <bst-photo-well [file]="school.logo" color="#f7f9fc" shape="rectangle"></bst-photo-well>
              }
              <div class="head">
                <div>
                  <label>
                    <span><b>{{ school.name }}</b></span>
                    @if (school.start) {
                      <span class="duration-pill">{{ school | span }}</span>
                    }
                  </label>
                  <label>
                    <span>@if (!school.end) {
                      <i>{{ 'ongoing' | translate }}&nbsp;</i>
                    }
                    <b>{{ 'degrees.'+school.degree | translate }}</b>
                    <b>&nbsp;{{ (!school.degree_finished && school.end ? 'studies' : 'degree') | translate }}</b>
                  </span>
                  @if (school.degree_major) {
                    <span>{{ (school.degree ? ', ' : '') + school.degree_major }}</span>
                  }
                  @if (school.start) {
                    <span>,&nbsp;&nbsp;<i>{{ school | frame }}</i></span>
                  }
                </label>
              </div>
              @if (!readonly) {
                <div class="edit-button">
                  <button nbButton size="tiny" type="button" (click)="openExperience(school)">
                    <nb-icon [icon]="'edit-2-outline'"></nb-icon><span>{{ 'edit...' | translate }}</span>
                  </button>
                </div>
              }
            </div>
            @if (school.description) {
              <div class="body">
                {{ school.description }}
              </div>
            }
            @if ((school.items | filter:{type: ExperienceType.CustomResponsibility}); as cres) {
              <div class="foot">
                <ul>
                  @for (res of cres; track res) {
                    <li>
                      {{ res.name }}
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        </div>
        <div class="panel-footer"></div>
      </article>
    }
  } @else {
    @if (readonly) {
      <label class="none">{{ 'nonelisted' | translate }}</label>
    }
  }
} @else {
  @if (readonly) {
    <label class="none">{{ 'nonelisted' | translate }}</label>
  }
}
</section>

<ng-template #footer let-popup="popup">
  <div class="spaced-footer">
    <div>
      <button nbButton (click)="popup.done(null)">{{ 'cancel' | translate }}</button>
      @if (!popup.instance.isNew) {
        <button nbButton status="danger" [disabled]="popup.instance.isMyCompany" (click)="delete(popup)">{{ (popup.instance.isSchool ? 'deleteeducation' : 'deletecompany') | translate }}</button>
      }
    </div>
    <button nbButton status="primary" [bstErroring]="popup.instance.form" (bstErroringSuccess)="popup.done(popup.instance)">{{ 'save' | translate }}</button>
  </div>
</ng-template>

<ng-template #elser>
  @if (readonly) {
    <label class="none">{{ 'nonelisted' | translate }}</label>
  }
</ng-template>
